import React from 'react';

import {Header} from '#components/header';
import {withPage} from '#pages';

import '#pages/notFound.css';

export const NotFound = withPage(() => (
  <div className="not-found">
    <Header title="404" subtitle="Not found" />
  </div>
));

